import React from 'react'
import injectSheet from 'react-jss'
import Draggable from 'react-draggable'
import NumberFormat from 'react-number-format'

class BudgetSliderHandle extends React.Component {
  constructor(props) {
    super(props)

    const { track, sliderMax } = props

    this.state = {
      position: props.initialPos * (track / sliderMax),
    }

    this.dragHandler = this.dragHandler.bind(this)
    this.dragHandlerStop = this.dragHandlerStop.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialPos !== this.state.position) {
      this.setState({
        position:
          nextProps.initialPos * (nextProps.track / nextProps.sliderMax),
      })
    }
  }

  dragHandler(e, ui) {
    const { position } = this.state
    this.setState({
      position: position + ui.deltaX,
    })
  }

  dragHandlerStop() {
    const {
      increment, setBudget, sliderMax, track,
    } = this.props
    const { position } = this.state

    setBudget(
      parseInt(position / (track / sliderMax) / increment, 10) * increment,
    )
  }

  render() {
    const {
      blocker,
      classes,
      currency,
      hasBlock,
      increment,
      leftBound,
      rightBound,
      sliderMax,
      title,
      track,
    } = this.props

    const { position } = this.state

    const value = position / (track / sliderMax)

    return (
      <div>
        <div>
          {hasBlock && (
            <React.Fragment>
              <div
                className={`${classes.handleBar} plot`}
                style={{
                  width: `${position * blocker.factor(position)}px`,
                  zIndex: 3,
                }}
              />
              <Draggable
                axis="x"
                disabled
                position={{
                  x: position * blocker.factor(position),
                  y: 0,
                }}
              >
                <div className={`${classes.handleBox} fix plot`}>
                  <div className={`${classes.handleTitle}`}>
                    {blocker.title}
                  </div>
                  <div className={`${classes.handle} fix`} />
                </div>
              </Draggable>
            </React.Fragment>
          )}
          <div
            className={`${classes.handleBar} auxiliaries`}
            style={{
              width: `${(hasBlock ? position * blocker.factor(position) : 0) +
                blocker.auxiliaries(value) * (track / sliderMax)}px`,
              zIndex: 2,
            }}
          />
          <Draggable
            axis="x"
            disabled
            position={{
              x:
                (hasBlock ? position * blocker.factor(position) : 0) +
                blocker.auxiliaries(value) * (track / sliderMax),
              y: 0,
            }}
          >
            <div className={`${classes.handleBox} fix auxiliaries`}>
              <div className={`${classes.handleTitle}`}>
                {blocker.auxiliariesShort}
              </div>
              <div className={`${classes.handle} fix`} />
            </div>
          </Draggable>
        </div>
        <div
          className={`${classes.handleBar}`}
          style={{
            width: `${position}px`,
            zIndex: 1,
          }}
        />
        <Draggable
          axis="x"
          bounds={{
            left: leftBound * (track / sliderMax),
            right: (rightBound + 1) * (track / sliderMax),
          }}
          onDrag={this.dragHandler}
          onStop={this.dragHandlerStop}
          position={{
            x: position,
            y: 0,
          }}
        >
          <div className={`${classes.handleBox}`}>
            <div className={`${classes.handleTitle}`}>{title}</div>
            <div className={`${classes.handle}`} />
            <div className={`${classes.handleValue}`}>
              <NumberFormat
                className={`${classes.handleValueFormat}`}
                displayType="text"
                value={
                  parseInt(position / (track / sliderMax) / increment, 10) *
                  increment
                }
                thousandSeparator="'"
                suffix={` ${currency}`}
              />
            </div>
          </div>
        </Draggable>
      </div>
    )
  }
}

const styles = theme => ({
  handleBar: {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '100%',
    background: theme.colors.main_1,
    borderRadius: '5px',
    '&.plot': {
      backgroundColor: theme.colors.main_5,
    },
    '&.auxiliaries': {
      borderWidth: '5px',
      borderColor: theme.colors.main_4,
      borderStyle: 'solid',
      background: `repeating-linear-gradient(
        225deg,
        ${theme.colors.main_4},
        ${theme.colors.main_4} 8px,
        ${theme.colors.secondary_3c} 8px,
        ${theme.colors.secondary_3c} 10px
      ) fixed`,
    },
  },
  handleBox: {
    position: 'relative',
    width: 0,
    height: 0,
    zIndex: 10,
    color: theme.colors.main_1,
    fontWeight: 'bold',
    '&.plot': {
      color: theme.colors.main_5,
      '& $handleTitle': {
        left: 'unset',
        right: 0,
        transform: 'translateX(0)',
      },
    },
    '&.auxiliaries': {
      color: theme.colors.main_4,
    },
    '&.fix $handleTitle': {
      top: '-20px',
      fontSize: '60%',
    },
  },
  handle: {
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: theme.colors.main_1,
    backgroundColor: theme.colors.main_2,
    '&.fix': {
      top: '10px',
      width: '5px',
      background: theme.colors.secondary_3c,
      borderColor: theme.colors.secondary_3c,
      borderRadius: 0,
    },
  },
  handleTitle: {
    position: 'absolute',
    top: '-20px',
    left: '50%',
    transform: 'translateX(-70%)',
    backgroundColor: theme.colors.main_2,
    fontSize: '60%',
    [theme.media.medium]: {
      top: '-30px',
      fontSize: '80%',
      transform: 'translateX(-60%)',
    },
    [theme.media.large]: {
      top: '-40px',
      fontSize: '100%',
      transform: 'translateX(-50%)',
    },
  },
  handleValue: {
    position: 'absolute',
    top: '30px',
    left: '50%',
    transform: 'translateX(-70%)',
    [theme.media.medium]: {
      top: '40px',
      fontSize: '80%',
      transform: 'translateX(-60%)',
    },
    [theme.media.large]: {
      fontSize: '100%',
      transform: 'translateX(-50%)',
    },
  },
  handleValueFormat: {
    display: 'block',
    backgroundColor: theme.colors.main_2,
    textAlign: 'center',
    fontSize: '60%',
    [theme.media.medium]: {
      fontSize: '80%',
    },
    [theme.media.large]: {
      fontSize: '100%',
    },
  },
})

export default injectSheet(styles)(BudgetSliderHandle)



// WEBPACK FOOTER //
// ./src/modules/budget/components/budgetSliderHandle.jsx